import(/* webpackMode: "eager", webpackExports: ["LandningView"] */ "/app/src/sections/landning/landning-view.tsx");
